console.log("gsap");

var $ = jQuery;

import { gsap, ScrollTrigger, ScrollToPlugin, CSSRulePlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(CSSRulePlugin);
gsap.registerPlugin(CSSRulePlugin);

// let sections = gsap.utils.toArray(".wrapper1"),
//   currentSection = sections[0];

// gsap.defaults({ overwrite: "auto", duration: 1 });

// gsap.set("body", { height: sections.length * 100 + "%" });

// sections.forEach((section, i) => {
//   ScrollTrigger.create({
//     start: () => (i - 0.5) * innerHeight,
//     end: () => (i + 0.5) * innerHeight,
//     scrub: true,
//     markers: true,
//     toggleActions: "play reset play reset",
//     // when a new section activates (from either direction), set the section accordingly.
//     onToggle: (self) => self.isActive && setSection(section),
//   });
// });

// function setSection(newSection) {
//   if (newSection !== currentSection) {
//     gsap
//       .timeline()
//       .to(currentSection.querySelector("h1"), {
//         y: -30,
//         autoAlpha: 0,
//         duration: 0.3,
//       })
//       .to(currentSection, { autoAlpha: 0, duration: 0.5 });

//     gsap
//       .timeline()
//       .to(newSection, { autoAlpha: 1, duration: 0.5 })
//       .fromTo(
//         newSection.querySelector("h1"),
//         { y: 30, autoAlpha: 0 },
//         { autoAlpha: 1, y: 0, duration: 0.3 }
//       );

//     currentSection = newSection;
//   }
// }

// * animazione con funzione foreach
// -----------------------------
function animateFrom(elem, direction) {
  direction = direction || 1;
  var x = 0,
    y = direction * 100;

  if (elem.classList.contains("fromleft")) {
    x = -75;
    y = 0;
    stagger: 0.5;
  } else if (elem.classList.contains("fromright")) {
    x = 75;
    y = 0;
  }

  elem.style.transform = "translate(" + x + "px, " + y + "px)";
  elem.style.opacity = "0";
  gsap.fromTo(
    elem,
    { x: x, y: y, autoAlpha: 0, overwrite: true },
    {
      duration: 1,
      x: 0,
      y: 0,
      autoAlpha: 1,
      ease: "power4.out",
    }
  );
}
function animateFromLeft(elem) {}
function hide(elem) {
  gsap.set(elem, { autoAlpha: 0, overwrite: true });
}

// * animazioni animateFrom con scrolltrigger e funzione esterna
// -----------------------------inizio
gsap.utils.toArray(".anim, .fromleft, .fromright").forEach((elem) => {
  hide(elem); // assure that the element is hidden when scrolled into view

  ScrollTrigger.create({
    trigger: elem,
    //trigger: "top 75%",
    onEnter: function () {
      animateFrom(elem);
    },
    onEnterBack: function () {
      animateFrom(elem, -1);
    },
    onLeave: function () {
      hide(elem);
    }, // assure that the element is hidden when scrolled into view
  });
});

// * animazione fadein con scrolltrigger batch
// -----------------------------inizio
ScrollTrigger.batch(".wrapper2, .wrapper3, .wrapper4", {
  interval: 0.2, // time window (in seconds) for batching to occur. The first callback that occurs (of its type) will start the timer, and when it elapses, any other similar callbacks for other targets will be batched into an array and fed to the callback. Default is 0.1
  //batchMax: 3, // maximum batch size (targets)
  onEnter: (batch) =>
    gsap.to(batch, { autoAlpha: 1, stagger: 0.15, overwrite: true }),
  onLeave: (batch) => gsap.set(batch, { autoAlpha: 0, overwrite: true }),
  onEnterBack: (batch) =>
    gsap.to(batch, { autoAlpha: 1, stagger: 0.15, overwrite: true }),
  onLeaveBack: (batch) => gsap.set(batch, { autoAlpha: 0, overwrite: true }),
  // you can also define things like start, end, etc.
  start: "top 75%",
  delay: 1,
});
